import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {BeforeCreateGameEvent} from "@/modules/base/events/BeforeCreateGameEvent";
import {Season} from "@/modules/season/entity";
import dayjs from "dayjs";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeCreateGameEvent, callback: this.onBeforeCreateGameEvent},
    ];
  }

  async onBeforeCreateGameEvent(event: BeforeCreateGameEvent) {
    if (this.configRepository.get('debug')) {
      await times(5, 1).forEachAsync(async (i: number) => {
        const season = new Season();
        season.current = false;
        season.currentDateRaw = dayjs.utc().subtract(i, 'year').toDate();
        await season.save();
      });
    }
  }
}